<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          v-model="filterStatus"
          name="radiosBtn"
          @change.native="preprocessFilter"
        >
          <b-form-radio
            class="mx-0 standardizedShortWidth"
            style="cursor: pointer;"
            value="active"
            >Recent</b-form-radio
          >
          <b-form-radio
            class="mx-0 standardizedShortWidth"
            style="cursor: pointer;"
            value="all"
            >Show All</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
      <b-col lg="2">
        <b-button
          class="mr-2 mt-0 btn-orange"
          style="color: white;"
          type="submit"
          size="md"
          @click="newEntity"
        >
          <i v-b-tooltip title="Add" class="fa fa-plus"></i>
          New Campaign
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <!-- <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template> -->
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "CampaignList",
  data: () => {
    return {
      fields: [
        // {
        //   key: "Functions",
        //   label: "",
        //   sortable: false,
        //   thStyle: "width: 5%;"
        // },
        {
          key: "PONumber",
          label: "PONumber",
          sortable: true,
          thStyle: "width: 15%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "campaign_name",
          label: "Campaign Name",
          sortable: true,
          thStyle: "width: 25%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "Dealership.InternalDealerID",
          label: "DealerID",
          sortable: true,
          thStyle: "width: 15%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "Dealership.Name",
          label: "Dealer Name",
          sortable: true,
          thStyle: "width: 30%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "broadcast_date",
          label: "Broadcast Date",
          sortable: true,
          thStyle: "width: 15%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      filterStatus: "active"
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.campaign.campaigns.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["n_user", "campaign", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    async myLoadComponent() {
      await this.$store.dispatch(
        "campaign/fetchRestrictedCampaigns",
        this.$store.state.n_user.n_current_user.UserProfileID
      );
      //     await this.$store.dispatch("campaign/fetchCampaigns");

      this.filterList();
      await this.$store.dispatch("n_user/fetchUsers");
      await this.$store.dispatch("n_user/fetchUserGroups");
      await this.$store.dispatch("dealer/fetchDealers");
      await this.$store.dispatch("dealer/fetchDealerGroups");
      await this.$store.dispatch("campaign/fetchCampaignTypes");
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store
        .dispatch("campaign/loadCampaignReport", record.PONumber)
        .then(() => {
          this.$router.push({ path: "campaigns/analytics" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("campaign/newCampaign", this.createFreshObject())
        //.dispatch("campaign/objectFactory")
        .then(() => {
          this.$router.push({ path: "campaigns/edit" });
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    preprocessFilter: function(event) {
      this.filterList();
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.campaign.campaigns;
      this.filteredObjects = this.filteredObjects.filter(
        campaign => campaign.DealershipID > 0
      );
      if (this.filterStatus === "active") {
        this.filteredObjects = this.filteredObjects.filter(
          campaign => campaign.IsRecent == true
        );
      }

      this.filteredObjects = this.filteredObjects.filter(
        campaign =>
          campaign.campaign_name
            .toLowerCase()
            .indexOf(this.searchString.toLowerCase()) > -1 ||
          campaign.Dealership.Name.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          campaign.Dealership.Name.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          campaign.PONumber.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      return {
        CampaignStatID: -1,
        campaign_name: ""
      };
    }
  },
  watch: {
    "$store.state.campaign.campaigns.length": function(oldValue, newValue) {
      this.filterList();
    }
  }
};
</script>

<style>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
